<template>
	<el-row class="ai-platform">
		<el-col :md="24" :lg="24" :xl="24">
			<div class="product-area">
				<div class="title">{{moduleName}}</div>
        <span class="subtitle">{{subtitle}}</span>
        <div class="middle">
          <div v-for="(item, index) in features" :class="(index%2===0) ? 'div-feature-up' : 'div-feature-down'">
            <img class="image" :src="item.src"/>
            <div class="description">
              <div class="title">{{ item.name }}</div>
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
        </div>

			</div>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		name: 'Product',
		data() {
			return {
				moduleName: 'MoPaaS人工智能平台',
        subtitle: 'MoPaaS人工智能平台基于TensorFlow、Caffe、Torch和Anaconda等主流深度学习框架，通过灵活调度、按需服务化的方式，提供AI算法训练、模型托管服务，为深度学习技术的研发和应用提供可靠性高、扩展灵活的云端托管服务',
        features: [
          {
					id: '1',
					name: '扩展灵活',
					content: '资源配置灵活扩容',
					src: require('@/assets/images/extension.png'),
          },
          {
            id: '2',
            name: '主流架构',
            content: '平台支持TensorFlow、Caffe、Torch和Anaconda等主流深度学习框架',
            src: require('@/assets/images/framework.png'),
          },
          {
            id: '3',
            name: '秒级计算',
            content: '平台资源秒级计算，按量付费，用多少扣多少',
            src: require('@/assets/images/compute.png'),
          },
          {
            id: '4',
            name: '云端托管',
            content: '提供PaaS平台部署技术',
            src: require('@/assets/images/cloud.png'),
          }
        ]
			}
		}
	}
</script>

<style>
	@media(min-width:992px) {
    .ai-platform {
      height: 868px;
      background: #F5F6F9;
    }
    .ai-platform .title {
      width: 298px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
      margin: 120px auto 0;
    }
    .ai-platform .subtitle {
      display: inline-block;
      width: 873px;
      height: 52px;
      font-size: 16px;
      font-weight: 400;
      color: #64626A;
      line-height: 26px;
      margin: 40px auto 0;
      opacity: 0.8;
    }
    .ai-platform .middle {
      margin: 58px auto 120px;
      width: 1376px;
      display: flex;
      justify-content: space-around;
    }
    .ai-platform .middle .description {
      width: 320px;
      height: 320px;
      background: #ffffff;
      margin-top: 83px;
    }
    .ai-platform .middle .image {
      width: 167px;
      height: 167px;
      position: absolute;
      left: 76px;
    }
    .ai-platform .middle .description .title {
      width: 104px;
      height: 37px;
      font-size: 26px;
      font-weight: 500;
      color: #3B3A40;
      line-height: 37px;
      margin: 119px auto 0 !important;
      display: inline-block;
    }
    .ai-platform .middle .description .content {
      width: 250px;
      height: 26px;
      font-size: 16px;
      font-weight: 400;
      color: #64626A;
      line-height: 26px;
      margin: 23px auto 0;
      opacity: 0.8;
    }
    .ai-platform .middle .div-feature-up {
      background: transparent;
      position: relative;
    }
    .ai-platform .middle .div-feature-down {
      margin-top: 41px;
      background: transparent;
      position: relative;
    }
	}

	@media(max-width:992px) {
    .ai-platform {
      background: #F5F6F9;
      padding: 6vw;
    }
    .ai-platform .title {
      font-size: 20px;
      font-weight: 400;
      color: #3A3F4D;
      line-height: 24px;
    }
    .ai-platform .subtitle {
      display: inline-block;
      font-size: 16px;
      font-weight: 300;
      color: #64626A;
      line-height: 22px;
      margin: 6vw auto 0;
      opacity: 0.8;
    }
    .ai-platform .middle {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 50%);
      margin-top: 6vw;
    }
    .ai-platform .middle .description {
      width: 42vw;
      height: 45vw;
      background: #ffffff;
      margin: -15vw auto 0;
    }
    .ai-platform .middle .image {
      width: 30vw;
      height: 30vw;
    }
    .ai-platform .middle .description .title {
      font-size: 20px;
      font-weight: 500;
      color: #3B3A40;
      line-height: 26px;
      margin: 17vw auto 0 !important;
      display: inline-block;
    }
    .ai-platform .middle .description .content {
      width: 36vw;
      font-size: 12px;
      font-weight: 400;
      color: #64626A;
      line-height: 14px;
      margin: 6vw auto 0;
      opacity: 0.8;
    }
    .ai-platform .middle .div-feature-up {
      background: transparent;
      position: relative;
    }
    .ai-platform .middle .div-feature-down {
      background: transparent;
      position: relative;
    }
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/AiPlatform.vue